import api from "../../../../../api/axios";
// import { Axios } from "../../../../../legacyComponents/util"

export default async function deleteInsuranceProof(insuranceProof) {
  try {
    const url = `user/healthInsurance/${insuranceProof?.userHealthInsuranceId}/document/${insuranceProof?.id}`;
    await api.delete(url);
  } catch (error) {
    console.error(error);
  }
}
